import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import React from "react";
import './confirmDeleteModal.css';
import { IConfirmDeleteModal } from "./IConfirmDeleteModal";

const css = `
.MuiTypography-root{
    font-size: 14px;
}
`;
const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
};

function ConfirmDeleteModal({ text,
    buttonTitle,
    delButton,
    openModal,
    setConfirm,
    setOpenVerifyModal,
    deleteTitle,
}: IConfirmDeleteModal) {

    const [open, setOpen] = React.useState<boolean>(openModal);
    const handleClose = () => { setOpen(false); setOpenVerifyModal(false) };
    const handleOpen = () => setOpen(true);
    const handelVerify = () => {
        setConfirm(true)
    };
    const handelCancel = () => { handleClose() };

    React.useEffect(() => {
        setOpen(openModal);
    }, [openModal]);


    return (<>
        <style>{css}</style>
        <Modal open={open}
            onClose={handleClose}
            className="border300"
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
        >
            <Box className="deleteBoxModal" sx={style} style={{ borderRadius: "5px", padding: "3vh", direction: 'rtl' }}>
                <div style={{ marginBottom: '3vh', marginTop: '3vh' }}>
                    <Typography className="text-[var(--primary-text-color)] text-center !font-bold  anjomanRegular" style={{ fontSize: '14px' }}>
                        {text}
                    </Typography>
                </div>
                <Grid container spacing={2} columns={16}>
                    <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                        <Button
                            style={{
                                minHeight: ' 42px', fontSize: '15px', alignItems: 'center',
                                paddingTop: '9px'
                            }}
                            onClick={handelVerify}
                            fullWidth
                            sx={{

                                background: delButton ? "#FF617C" : "var(--button-color)",
                                color: delButton ? "#ffffff" : 'var(--semilar-color)',
                                "&:hover": {
                                    background: delButton ? "#FF617C" : "var(--button-color)",
                                },
                                "&:active": {
                                    boxShadow: "none",
                                    background: delButton ? "#FF617C" : "var(--button-color)",
                                },
                                "&:focus": {
                                    outline: "none",
                                },
                            }}
                            className={`btnClassSuccess text-white !font-bold `}
                        >
                            {buttonTitle}
                        </Button>
                    </Grid>
                    <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                        <Button
                            style={{
                                minHeight: ' 42px', fontSize: '15px', alignItems: 'center',
                                paddingTop: '9px'
                            }}

                            onClick={handelCancel}
                            fullWidth
                            className="bgPrimaryColorLight-100 btnClassCancel witheColor !font-bold"
                            sx={{
                                "&:hover": {
                                    background: "inherit",
                                },
                                "&:active": {
                                    boxShadow: "none",
                                    background: "inherit",
                                },
                                "&:focus": {
                                    outline: "none",
                                },
                            }}
                        >
                            {deleteTitle ? deleteTitle : "انصراف"}
                        </Button>
                    </Grid>
                </Grid>
            </Box>

        </Modal>
    </>);
}

export default ConfirmDeleteModal;